import React, { useEffect, useState, useContext } from "react";
import { useParams } from "react-router-dom";
import Navbar from "../../layout/Navbar/Navbar";
import Sidebar from "../../layout/Sidebar/SideBar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import DeleteIcon from "@mui/icons-material/Delete";
import PrintIcon from "@mui/icons-material/Print";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import "moment/locale/pt-br";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { TextField, Button } from "@mui/material";
import blogFetch from "../../axios/config";
import generatePDF from "./pdfInvoice";
import generatePDF2 from "./pdfInvoiceBox";
import InvoiceEtiquetas from "./EtiquetaInvoice";
import dayjs from "dayjs";
import { StyleSheet } from "@react-pdf/renderer";
import SaveIcon from "@mui/icons-material/Save";
import SearchIcon from "@mui/icons-material/Search";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import Context from "../../context/Context";

export default function Invoice() {
  const params = useParams();
  const { order } = params;
  const [invoices, setInvoices] = useState([]);
  const [selectedInvoice, setSelectedInvoice] = useState([]);
  const [invoiceLenguage, setInvoiceLenguage] = useState([]);
  const [selectedLenguage, setSelectedLenguage] = useState([]);
  const [selectedNCM, setSelectedNCM] = useState([]);
  const [responsibleInvoice, setResponsibleInvoice] = useState([]);
  const [selectedResponsibleInvoice, setSelectedResponsibleInvoice] = useState(
    []
  );
  const [status, setStatus] = useState("");
  const [dataEmbarque, setDataEmbarque] = useState(null);
  const [dataDesembarque, setDataDesembarque] = useState(null);
  const [dataLiberacao, setDataLiberacao] = useState(null);
  const [dataSolicitacao, setDataSolicitacao] = useState(null);
  const [filterInvoice, setFilterInvoice] = useState(null);
  const [loadingProcedure, setLoadingProcedure] = useState(false);
  const [inputValues, setInputValues] = useState({
    Packing: order,
    InvoiceStatus: status,
    dtDesembarque: null,
    dtEmbarque: null,
    dtLiberacaoExercito: null,
    dtSolicitacaoExercito: null,
    emailResponsavel: " ",
    embalagem: " ",
    metragem: " ",
    pesoBruto: " ",
    notas: " ",
    seguro: " ",
    pesoLiquido: " ",
    qtdeTotal: " ",
    responsavel: " ",
    status_Invoice: " ",
    trFrSeg: " ",
    tipo_Seguro: " ",
    Language: selectedLenguage,
  });

  const {
    getStatusSideBar,
  } = useContext(Context);

  const etiquetasDeExemplo = [
    {
      nome: "Cliente 1",
      endereco: "Rua A, 123",
      valor: "R$ 100,00",
    },
    {
      nome: "Cliente 2",
      endereco: "Rua B, 456",
      valor: "R$ 150,00",
    },
    {
      nome: "Cliente 3",
      endereco: "Rua C, 789",
      valor: "R$ 75,00",
    },
  ];

  const styles = StyleSheet.create({
    tableHeader: {
      fontSize: 14,
      fontWeight: "bold",
      whiteSpace: "nowrap",
      backgroundColor: "#9ed6de",
    },
  });

  const hover = {
    "&:hover": {
      backgroundColor: "gray",
      cursor: "pointer",
    },
  };

  useEffect(() => {
    if (order) {
      let updateOrder = { packing: order };
      setSelectedInvoice(updateOrder);
    }
    getInvoices();
    getInvoiceLenguage();
    getResponsibleInvoice();
    setStatus("Criado");
  }, []);

  useEffect(() => {
    if (selectedInvoice && Object.keys(selectedInvoice).length > 0) {
      const updatedInvoice = { ...selectedInvoice };
      updatedInvoice.dtEmbarque = validData(updatedInvoice.dtEmbarque);
      updatedInvoice.dtDesembarque = validData(updatedInvoice.dtDesembarque);
      updatedInvoice.dtLiberacaoExercito = validData(
        updatedInvoice.dtLiberacaoExercito
      );
      updatedInvoice.dtSolicitacaoExercito = validData(
        updatedInvoice.dtSolicitacaoExercito
      );
      setInputValues(updatedInvoice);
      setDataEmbarque(updatedInvoice.dtEmbarque);
      setDataDesembarque(updatedInvoice.dtDesembarque);
      setDataLiberacao(updatedInvoice.dtLiberacaoExercito);
      setDataSolicitacao(updatedInvoice.dtSolicitacaoExercito);
      getResponsibleInvoiceByName(selectedInvoice.responsavel);
    }
  }, [selectedInvoice]);

  const handleDateChangeEmbarque = (date) => {
    setDataEmbarque(date);
  };
  const handleDateChangeDesembarque = (date) => {
    setDataDesembarque(date);
  };
  const handleDateChangeSolicitacao = (date) => {
    setDataSolicitacao(date);
  };
  const handleDateChangeLiberacao = (date) => {
    setDataLiberacao(date);
  };

  const handleChangeStatus = (event) => {
    setStatus(event.target.value);
  };
  const handleChangeLenguage = (event) => {
    setSelectedLenguage(event.target.value);
  };
  const handleChangeNCM = (event) => {
    setSelectedNCM(event.target.value);
  };
  const handleChangeResponsibleInvoice = (event) => {
    setSelectedResponsibleInvoice(event.target.value);
  };

  const handleInputChange = (event, nameObj) => {
    setInputValues({
      ...inputValues,
      [nameObj]: event.target.value,
    });
  };

  const validData = (dateString) => {
    dayjs.locale("pt-br");
    const receivedDate = dayjs(dateString);
    const zeroDate = dayjs("1900-01-01");

    if (!dateString || receivedDate.isSame(zeroDate)) {
      return "";
    }
    const parsedDate = dayjs(dateString);
    return parsedDate;
  };

  const getInvoice = async (packing) => {
    try {
      let response = await blogFetch.get("/invoice/" + packing);
      let data = response.data;
      setInvoices(data);
    } catch (error) {
      console.error(error);
    }
  };

  const getInvoiceForPdf = async (order) => {
    try {
      let response = await blogFetch.get("/invoice/all_?order=" + order);
      let data = response.data;
      return data;
    } catch (error) {
      console.error(error);
    }
  };

  const getInvoices = async () => {
    try {
      let response = await blogFetch.get("/invoice");
      let data = response.data;
      setInvoices(data);
    } catch (error) {
      console.error(error);
    }
  };

  const getInvoiceLenguage = async () => {
    try {
      let response = await blogFetch.get("/InvoiceTraducao");
      let data = response.data;
      setSelectedLenguage(data[0].trad_Language);
      setInvoiceLenguage(data);
      return data;
    } catch (error) {
      console.error(error);
    }
  };
  const getResponsibleInvoice = async () => {
    try {
      let response = await blogFetch.get("/ResponsibleInvoice");
      let data = response.data;
      setResponsibleInvoice(data);
      return data;
    } catch (error) {
      console.error(error);
    }
  };
  const getResponsibleInvoiceByName = async (name) => {
    try {
      let response = await blogFetch.get("/ResponsibleInvoice/" + name);
      let data = response.data;
      setSelectedResponsibleInvoice(data.responsibleInvoice_Name);
      return data;
    } catch (error) {
      console.error(error);
    }
  };
  const getInvoiceLenguagebyId = async (lenguage) => {
    try {
      let response = await blogFetch.get("/InvoiceTraducao/" + lenguage);
      let data = response.data;
      return data;
    } catch (error) {
      console.error(error);
    }
  };

  const getNameInvoice = async (order) => {
    try {
      let response = await blogFetch.get("invoice/indice/" + order);
      let data = response.data;

      return data;
    } catch (error) {
      console.error(error);
    }
  };

  const setInvoiceProcedure = async (obj) => {
    try {
      let response = await blogFetch.post("/invoice/procedure_", obj);
      let data = response.status;
      return data;
    } catch (error) {
      console.error(error);
    }
  };

  const updateInvoice = async () => {
    setLoadingProcedure(true);
    let packing = order;
    if (!order) {
      packing = inputValues.packing;
    }
    var matchedObject = responsibleInvoice.find(
      (obj) => obj.responsibleInvoice_Name === selectedResponsibleInvoice
    );

    let invoice = {
      Packing: packing,
      Packaging: "Caixa de Madeira",
      TotalQuantity: 0,
      Measurement: 0,
      Responsible: matchedObject.responsibleInvoice_Name,
      ResponsibleEmail: matchedObject.responsibleInvoice_Email,
      Notes: inputValues.notas || "",
      NetWeight: 0,
      GrossWeight: 0,
      FreightTariff: inputValues.trFrSeg,
      InvoiceStatus: status,
      ShippingDate: dataEmbarque,
      UnloadingDate: dataDesembarque,
      ArmyRequestDate: dataSolicitacao,
      ArmyReleaseDate: dataLiberacao,
      Language: selectedLenguage,
      Insurance: inputValues.seguro,
    };
    if (dataDesembarque === "") {
      delete invoice.UnloadingDate;
    }

    if (dataSolicitacao === "") {
      delete invoice.ArmyRequestDate;
    }

    if (dataLiberacao === "") {
      delete invoice.ArmyReleaseDate;
    }

    let ret = await setInvoiceProcedure(invoice);
    await getInvoices();
    if (ret != 200) {
      alert("Erro atualizar/Criar Invoice");
    }

    setLoadingProcedure(false);
  };

  const openPdf = async () => {
    let data = await getInvoiceForPdf(selectedInvoice.packing);
    let lenguage = await getInvoiceLenguagebyId(selectedLenguage);
    let nameInvoice = "";
    let indice = await getNameInvoice(data[0].pedidoVenda);
    if (indice.length > 1) {
      const matchingIndice = indice.find(
        (item) => item.packing === data[0].packing
      );

      if (matchingIndice) {
        nameInvoice = matchingIndice.indice;
      }
    }
    generatePDF(data, lenguage, selectedNCM, nameInvoice);
  };

  const openPdf2 = async () => {
    let data = await getInvoiceForPdf(selectedInvoice.packing);
    let lenguage = await getInvoiceLenguagebyId(selectedLenguage);
    let nameInvoice = "";
    let indice = await getNameInvoice(data[0].pedidoVenda);
    if (indice.length > 1) {
      const matchingIndice = indice.find(
        (item) => item.packing === data[0].packing
      );

      if (matchingIndice) {
        nameInvoice = matchingIndice.indice;
      }
    }

    generatePDF2(data, lenguage, selectedNCM, nameInvoice);
  };
  const printEtiquetas = async () => {
    let data = await getInvoiceForPdf(selectedInvoice.packing);

    InvoiceEtiquetas(data);
  };

  const deletePacking = async () => {
    try {
      const confirmed = window.confirm(
        "Tem certeza de que deseja excluir este registro?"
      );

      if (confirmed) {
        await blogFetch.delete("/invoice/" + selectedInvoice.packing);
        await getInvoices();
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      <Navbar />
      <Sidebar />
      <div
        className={`app_body ${getStatusSideBar()}`}
        style={{ backgroundColor: "#f3f3f3" }}
      >
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              width: "50%",
              padding: 20,
              gap: 10,
              borderRight: "1px solid ",
            }}
          >
            <h2 className="title_tables">
              Status da Invoice
            </h2>
            <h2 style={{ textAlign: "center" }}>{selectedInvoice.packing}</h2>
            <div style={{ width: "100%" }}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Status</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={status}
                  label="Status"
                  size="small"
                  onChange={handleChangeStatus}
                  style={{ backgroundColor: "white", borderRadius: "5px" }}
                >
                  <MenuItem value={"Criado"}>Criado</MenuItem>
                  <MenuItem value={"Atualizado"}>Atualizado</MenuItem>
                  <MenuItem value={"Finalizado"}>Finalizado</MenuItem>
                </Select>
              </FormControl>
            </div>
            <div
              style={{
                display: "flex",
                width: "100%",
                gap: 10,
              }}
            >
              <LocalizationProvider dateAdapter={AdapterDayjs} fullWidth>
                <DatePicker
                  label="Embarque"
                  format="DD/MM/YYYY"
                  className="date-piker"
                  sx={{
                    width: "50%",
                    backgroundColor: "white",
                    borderRadius: "5px",
                  }}
                  value={dataEmbarque}
                  onChange={handleDateChangeEmbarque}
                />
              </LocalizationProvider>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="Desembarque"
                  format="DD/MM/YYYY"
                  className="date-picker"
                  value={dataDesembarque}
                  onChange={handleDateChangeDesembarque}
                  sx={{
                    width: "50%",
                    backgroundColor: "white",
                    borderRadius: "5px",
                  }}
                />
              </LocalizationProvider>
            </div>
            <div
              style={{
                display: "flex",
                width: "100%",
                gap: 10,
              }}
            >
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="Solicitação Exercito"
                  fullWidth
                  format="DD/MM/YYYY"
                  className="date-piker"
                  value={dataSolicitacao}
                  onChange={handleDateChangeSolicitacao}
                  sx={{
                    width: "50%",
                    backgroundColor: "white",
                    borderRadius: "5px",
                  }}
                />
              </LocalizationProvider>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="Liberação Exercito"
                  fullWidth
                  format="DD/MM/YYYY"
                  className="date-piker"
                  value={dataLiberacao}
                  onChange={handleDateChangeLiberacao}
                  sx={{
                    width: "50%",
                    backgroundColor: "white",
                    borderRadius: "5px",
                  }}
                />
              </LocalizationProvider>
            </div>
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">Responsável</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={selectedResponsibleInvoice}
                label="Responsável"
                size="small"
                onChange={handleChangeResponsibleInvoice}
                sx={{ backgroundColor: "white", borderRadius: "5px" }}
              >
                {!!responsibleInvoice &&
                  Object.entries(responsibleInvoice).map((item) => {
                    return (
                      <MenuItem value={item[1].responsibleInvoice_Name}>
                        {item[1].responsibleInvoice_Name}
                      </MenuItem>
                    );
                  })}
              </Select>
            </FormControl>
            <TextField
              id="outlined-basic"
              label="Notas"
              variant="outlined"
              size="small"
              fullWidth
              name="notas"
              value={inputValues?.notas}
              onChange={(event) => handleInputChange(event, "notas")}
              sx={{ backgroundColor: "white", borderRadius: "5px" }}
            />
            <TextField
              id="outlined-basic"
              label="Valor Seguro"
              variant="outlined"
              size="small"
              fullWidth
              type="number"
              name="valorSeguro"
              value={inputValues?.seguro}
              onChange={(event) => handleInputChange(event, "seguro")}
              sx={{ backgroundColor: "white", borderRadius: "5px" }}
            />
            <TextField
              id="outlined-basic"
              label="Tarifa Frete"
              variant="outlined"
              size="small"
              fullWidth
              type="number"
              name="tarifaFrete"
              value={inputValues?.trFrSeg}
              onChange={(event) => handleInputChange(event, "trFrSeg")}
              sx={{ backgroundColor: "white", borderRadius: "5px" }}
            />
            <div style={{ width: "100%" }}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Idioma</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={selectedLenguage}
                  label="Idioma"
                  size="small"
                  onChange={handleChangeLenguage}
                  sx={{ backgroundColor: "white", borderRadius: "5px" }}
                >
                  {!!invoiceLenguage &&
                    Object.entries(invoiceLenguage).map((item) => {
                      return (
                        <MenuItem value={item[1].trad_Language}>
                          {item[1].trad_Language}
                        </MenuItem>
                      );
                    })}
                </Select>
              </FormControl>
            </div>
            <div style={{ width: "100%" }}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">NCM</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={selectedNCM}
                  label="NCM"
                  size="small"
                  onChange={handleChangeNCM}
                  sx={{ backgroundColor: "white", borderRadius: "5px" }}
                >
                  <MenuItem value={"7007.21.10"}>7007.21.10</MenuItem>
                  <MenuItem value={"8708.22.00"}>8708.22.00</MenuItem>
                  <MenuItem value={"8708.29.99"}>8708.29.99</MenuItem>
                </Select>
              </FormControl>
            </div>
            <div>
              <div style={{ display: "flex", justifyContent: "end" }}>
                {loadingProcedure ? (
                  <FontAwesomeIcon icon={faSpinner} spin />
                ) : (
                  <Button
                    disabled={loadingProcedure}
                    className="btn mb-1"
                    variant="contained"
                    onClick={updateInvoice}
                    style={{ backgroundColor: "#007aa2" }}
                  >
                    Salvar Invoice
                    <SaveIcon />
                  </Button>
                )}
              </div>

              <div
                className="mb-1"
                style={{
                  justifyContent: "space-between",
                  display: "flex",
                  flexWrap: "wrap",
                }}
              >
                <Button
                  disabled={loadingProcedure}
                  className="btn"
                  variant="contained"
                  onClick={openPdf}
                  style={{ backgroundColor: "#007aa2" }}
                >
                  Gerar Invoice
                  <PictureAsPdfIcon />
                </Button>
                <Button
                  disabled={loadingProcedure}
                  className="btn"
                  variant="contained"
                  onClick={openPdf2}
                  style={{ backgroundColor: "#007aa2" }}
                >
                  Gerar Packing List
                  <CheckCircleIcon />
                </Button>
              </div>
              <div
                className="mb-1"
                style={{
                  justifyContent: "space-between",
                  display: "flex",
                  flexWrap: "wrap",
                }}
              >
                <Button
                  disabled={loadingProcedure}
                  className="btn"
                  variant="contained"
                  onClick={printEtiquetas}
                  style={{ backgroundColor: "#007aa2" }}
                >
                  Etiquetas
                  <PrintIcon />
                </Button>
                <Button
                  disabled={loadingProcedure}
                  className="btn"
                  variant="contained"
                  onClick={deletePacking}
                  style={{ backgroundColor: "#007aa2" }}
                >
                  Apagar
                  <DeleteIcon />
                </Button>
              </div>
            </div>
          </div>
          <div
            style={{
              width: "50%",
              padding: "10px 10px 10px 5px",
              textAlign: "center",
            }}
          >
            <h2 className="title_tables">
              Carregar Invoice
            </h2>
            <div
              className="mb-3"
              style={{
                display: "flex",
                justifyContent: "center",
              }}
            >
              <TextField
                id="outlined-basic"
                label="Packing List"
                variant="outlined"
                fullWidth
                value={filterInvoice}
                onChange={(event) => setFilterInvoice(event.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.keyCode === 13)
                    getInvoice(filterInvoice);
                }}
                sx={{ backgroundColor: "white", borderRadius: "5px" }}
              />
              <Button
                className="btn"
                variant="contained"
                onClick={() => getInvoice(filterInvoice)}
                style={{ marginRight: 10, backgroundColor: "#007aa2" }}
              >
                Pesquisar
                <SearchIcon />
              </Button>
            </div>

            <div style={{ overflowX: "auto" }}>
              <div style={{ overflowX: "auto" }}>
                <TableContainer>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell>Packing</TableCell>
                        <TableCell
                          align="center"
                          style={{
                            padding: "2px 10px",
                            fontSize: 14,
                            whiteSpace: "nowrap",
                          }}
                        >
                          QTDE Peças
                        </TableCell>
                        <TableCell
                          align="center"
                          style={{
                            padding: "2px 10px",
                            fontSize: 14,
                            whiteSpace: "nowrap",
                          }}
                        >
                          Pedido
                        </TableCell>
                        <TableCell
                          align="center"
                          style={{
                            padding: "2px 10px",
                            fontSize: 14,
                            whiteSpace: "nowrap",
                          }}
                        >
                          Pedido Genesis
                        </TableCell>
                        <TableCell
                          align="center"
                          style={{
                            padding: "2px 10px",
                            fontSize: 14,
                            whiteSpace: "nowrap",
                          }}
                        >
                          Status
                        </TableCell>
                        <TableCell
                          align="center"
                          style={{
                            padding: "2px 10px",
                            fontSize: 14,
                            whiteSpace: "nowrap",
                          }}
                        >
                          Destinatario
                        </TableCell>
                        <TableCell
                          align="center"
                          style={{
                            padding: "2px 10px",
                            fontSize: 14,
                            whiteSpace: "nowrap",
                          }}
                        >
                          Cidade Destino
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody sx={{}}>
                      {Object.entries(invoices).map((obj) => {
                        return (
                          <TableRow
                            hover
                            onClick={() => setSelectedInvoice(obj[1])}
                            key={obj[1].name}
                            sx={{ cursor: "pointer" }}
                          >
                            <TableCell
                              align="center"
                              style={{
                                padding: "2px 10px",
                                fontSize: 14,
                                whiteSpace: "nowrap",
                              }}
                            >
                              {obj[1].packing}
                            </TableCell>
                            <TableCell
                              align="center"
                              style={{
                                padding: "2px 10px",
                                fontSize: 14,
                                whiteSpace: "nowrap",
                              }}
                            >
                              {obj[1].qtdePeca}
                            </TableCell>
                            <TableCell
                              align="center"
                              style={{
                                padding: "2px 10px",
                                fontSize: 14,
                                whiteSpace: "nowrap",
                              }}
                            >
                              {obj[1].pedidoVenda}
                            </TableCell>
                            <TableCell
                              align="center"
                              style={{
                                padding: "2px 10px",
                                fontSize: 14,
                                whiteSpace: "nowrap",
                              }}
                            >
                              {obj[1].pedido_Genesis}
                            </TableCell>
                            <TableCell
                              align="center"
                              style={{
                                padding: "2px 10px",
                                fontSize: 14,
                                whiteSpace: "nowrap",
                              }}
                            >
                              {obj[1].status_Invoice}
                            </TableCell>
                            <TableCell
                              align="center"
                              style={{
                                padding: "2px 10px",
                                fontSize: 14,
                                whiteSpace: "nowrap",
                              }}
                            >
                              {obj[1].destinatario_Invoice}
                            </TableCell>
                            <TableCell
                              align="center"
                              style={{
                                padding: "2px 10px",
                                fontSize: 14,
                                whiteSpace: "nowrap",
                              }}
                            >
                              {obj[1].cidade_Dest_Invoice}
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                </TableContainer>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
